import { AxiosInstance } from 'axios';
import ManagerProfileRepository from '../application/ports/ManagerProfileRepository';
import { ManagerProfile } from '../domain/ManagerProfile';
import { mapManagerProfileDtoToDomain, ManagerProfileDto } from './mappers/managerProfileMapper';

const API_PATH = '/api/v2/managers/me/';

const buildManagerProfileError = (error: any): Error => {
  const detail = error?.response?.data?.detail;
  const err = new Error(detail || error.message || 'Manager profile request failed');
  (err as any).status = error?.response?.status;
  (err as any).data = error?.response?.data;
  return err;
};

class RestManagerProfileRepository extends ManagerProfileRepository {
  private readonly axiosInstance: AxiosInstance;

  constructor({ axiosInstance }: { axiosInstance: AxiosInstance }) {
    super();
    if (!axiosInstance) {
      throw new Error('RestManagerProfileRepository requires an axiosInstance');
    }
    this.axiosInstance = axiosInstance;
  }

  async getMyProfile(): Promise<ManagerProfile> {
    try {
      const response = await this.axiosInstance.get(API_PATH);
      return mapManagerProfileDtoToDomain(response.data as ManagerProfileDto);
    } catch (error) {
      throw buildManagerProfileError(error);
    }
  }
}

export default RestManagerProfileRepository;
